/**
 * Header course search modal.
 */
import React, { useState } from "react";
import { Box, Divider } from "@mui/material";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { BModal, BThumb } from "components";
import { VButton, VInput, VText } from "form";
import { useAsterController } from "context";
import { getCourseImageUrl } from "utils/string";

/**
 * Filters enrolled courses by name and lists matching results.
 */
const HeaderSearch = () => {
  const { t } = useTranslation("common");

  const [controller] = useAsterController();
  const { courses } = controller;

  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const filtered = (courses.data || []).filter((v) => v.display_name.includes(searchTerm)).slice(0, 10);

  return (
    <>
      <VButton iconButton variant="outlined" color="secondary" onClick={() => setOpen(true)} name="search">
        <Icon icon="bx:search" className="text-2xl" />
      </VButton>

      <BModal open={open} setOpen={setOpen} className="w-full max-w-lg">
        <Box className="py-4 w-full pr-12">
          <VInput startIcon="search" placeholder={t("Search contents")} size="small" className="v-input-noborder w-full" inputClassName="text-dark dark:text-white" noborder value={searchTerm} setValue={setSearchTerm} />
        </Box>
        <Divider className="bg-gray-200 dark:bg-gray-500" />
        <Box className="px-4 h-10 flex items-center">
          <VText>{t("Recent Result")}</VText>
        </Box>
        <Divider className="bg-gray-200 dark:bg-gray-500 mt-1" />

        <Box className="p-4" sx={{ minHeight: 320 }}>
          <VText color="secondary" className="text-lg">
            {t("Courses")}
          </VText>
          {filtered.length ? (
            filtered.map((course) => (
              <Link to={`/explore`} className="no-underline w-full" key={`${course.id}${course.created}`}>
                <Box className="flex items-center mt-2 hover:bg-gray-200 p-1">
                  <BThumb src={getCourseImageUrl(course.course_image_url)} className="w-28 h-14 rounded flex-shrink-0" />
                  <Box className="ml-4">
                    <VText>{course.display_name}</VText>
                    <Box className="flex">
                      <VText color="secondary" className="text-xs bg-gray-100 dark:bg-gray-700 rounded px-1 py-0.5 w-max flex items-center h-min">
                        <Icon icon="ic:outline-published-with-changes" />
                        &nbsp;{t("Published")}
                      </VText>
                      <VText color="secondary" className="text-xs rounded px-1 py-0.5 w-max flex items-center h-min ml-2">
                        <Icon icon="majesticons:award-line" />
                        &nbsp;{course.category || "-"}
                      </VText>
                      <VText color="secondary" className="text-xs rounded px-1 py-0.5 w-max flex items-center h-min ml-2">
                        <Icon icon="bx:user-circle" />
                        &nbsp;{t("Public")}
                      </VText>
                    </Box>
                  </Box>
                </Box>
              </Link>
            ))
          ) : (
            <Box className="h-80 flex flex-col justify-center items-center w-full">
              <Box className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center">
                <Box className="w-14 h-14 bg-gray-300 rounded-full flex items-center justify-center">
                  <Icon icon="mdi:selection-search" className="text-3xl text-white" />
                </Box>
              </Box>
              <VText className="text-sm mt-4">{t("Your search did not match with anything")}</VText>
            </Box>
          )}
        </Box>
      </BModal>
    </>
  );
};

export default HeaderSearch;
